// extracted by mini-css-extract-plugin
export var alignBottom = "full-bleed-module--alignBottom--f13c5";
export var alignCenter = "full-bleed-module--alignCenter--4f0a8";
export var alignTop = "full-bleed-module--alignTop--6667e";
export var bottom = "full-bleed-module--bottom--46cf7";
export var center = "full-bleed-module--center--a4226";
export var contentContainer = "full-bleed-module--contentContainer--b4f0b";
export var ctaContainer = "full-bleed-module--ctaContainer--739ce";
export var image = "full-bleed-module--image--394b4";
export var imageContainer = "full-bleed-module--imageContainer--b9984";
export var justifyCenter = "full-bleed-module--justifyCenter--725ae";
export var justifyLeft = "full-bleed-module--justifyLeft--86c6f";
export var justifyRight = "full-bleed-module--justifyRight--c152f";
export var mobileImage = "full-bleed-module--mobileImage--96329";
export var module85vh = "full-bleed-module--module85vh--232df";
export var moduleContainer = "full-bleed-module--moduleContainer--1775d";
export var moduleFitContent = "full-bleed-module--moduleFitContent--ff4c4";
export var top = "full-bleed-module--top--8e5cf";